/**
 * Axios 에러 객체에서 백엔드 한글 메시지를 우선 추출하는 유틸리티.
 *
 * 우선순위:
 *  1. error.response.data.error_msg  (백엔드 ErrorInfo DTO)
 *  2. error.response.data.message    (백엔드 일반 응답)
 *  3. error.message                  (throw new Error 등 JS 에러)
 *  4. fallback                       (호출부에서 지정한 기본 문구)
 *
 * @param {Error|Object} error    - Axios 에러 또는 일반 Error 객체
 * @param {string}       fallback - 위 모든 경로에서 메시지를 찾지 못했을 때 기본 문구
 * @returns {string} 사용자에게 표시할 에러 메시지
 */
function getApiErrorMessage(error, fallback = '오류가 발생했습니다.') {
  const data = error?.response?.data;

  if (data?.error_msg) return data.error_msg;
  if (data?.message) return data.message;
  if (error?.message) return error.message;

  return fallback;
}

export default getApiErrorMessage;
